export const SET_TABLE_CURRENT_PAGE = 'SET_TABLE_CURRENT_PAGE';

export function setTableCurrentPage(id: string, currentPage: number) {
  return {
    type: SET_TABLE_CURRENT_PAGE,
    payload: {
      id,
      currentPage,
    },
  };
}
